(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koszulka1-opinie"] && !Shopify.designMode) return;
  try {
    
(function(){
  function cols(r){var w=window.innerWidth;return w>=1000?(+r.getAttribute('data-cols')||6):(w>=640?4:2);}
  function layout(r,force){
    var g=r.querySelector('.k1o__grid'),n=cols(r);
    if(!force&&r._n===n)return;
    r._n=n;g.innerHTML='';g.classList.add('is-masonry');
    var cs=[];
    for(var i=0;i<n;i++){var c=document.createElement('div');c.className='k1o__col';g.appendChild(c);cs.push(c);}
    r._cards.forEach(function(card){
      var m=cs[0];
      for(var j=1;j<cs.length;j++){if(cs[j].offsetHeight<m.offsetHeight)m=cs[j];}
      m.appendChild(card);
    });
  }
  function init(){
    document.querySelectorAll('[data-k1o]:not([data-k1o-init])').forEach(function(r){
      r.setAttribute('data-k1o-init','1');
      r._cards=[].slice.call(r.querySelectorAll('.k1o__card'));
      layout(r,true);
      var s=r.querySelector('[data-k1o-sort]');
      if(s)s.addEventListener('change',function(){
        var v=s.value;
        r._cards.sort(function(a,b){
          var ia=+a.getAttribute('data-i'),ib=+b.getAttribute('data-i');
          if(v==='old')return ib-ia;
          if(v==='top'){var d=(+b.getAttribute('data-stars'))-(+a.getAttribute('data-stars'));return d||ia-ib;}
          return ia-ib;
        });
        layout(r,true);
      });
      var t;
      window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(function(){layout(r,false);},150);});
    });
  }
  init();
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koszulka1-sylwetka"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('[data-k1s-cmp]:not([data-k1s-init])').forEach(function(c){
      c.setAttribute('data-k1s-init','1');
      var root=c.closest('.k1s'),drag=false;
      function set(p){p=Math.max(0,Math.min(100,p));c.style.setProperty('--k1s-pos',p+'%');c.setAttribute('aria-valuenow',Math.round(p));}
      function fromX(x){var r=c.getBoundingClientRect();set((x-r.left)/r.width*100);}
      c.addEventListener('pointerdown',function(e){drag=true;try{c.setPointerCapture(e.pointerId);}catch(_){}fromX(e.clientX);});
      c.addEventListener('pointermove',function(e){if(drag)fromX(e.clientX);});
      c.addEventListener('pointerup',function(){drag=false;});
      c.addEventListener('pointercancel',function(){drag=false;});
      c.addEventListener('keydown',function(e){var v=+c.getAttribute('aria-valuenow');if(e.key==='ArrowLeft'){set(v-5);e.preventDefault();}if(e.key==='ArrowRight'){set(v+5);e.preventDefault();}});
      root.querySelectorAll('[data-k1s-btn]').forEach(function(b){
        b.addEventListener('click',function(){
          var n=b.getAttribute('data-k1s-btn');
          root.querySelectorAll('[data-k1s-btn]').forEach(function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-pressed',on?'true':'false');});
          root.querySelectorAll('[data-k1s-pair]').forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-k1s-pair')===n);});
          set(50);
        });
      });
    });
  }
  init();
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koszulka1-tabela"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__k1m)return;window.__k1m=1;
  function modal(){return document.querySelector('.k1m');}
  function open(){var m=modal();if(!m)return;m.classList.add('is-open');m.setAttribute('aria-hidden','false');document.documentElement.classList.add('k1m-lock');}
  function close(){var m=modal();if(!m)return;m.classList.remove('is-open');m.setAttribute('aria-hidden','true');document.documentElement.classList.remove('k1m-lock');}
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-k1-size-open],a[href="#tabela-rozmiarow"]');
    if(o){e.preventDefault();open();return;}
    if(e.target.closest('[data-k1m-close]')){close();return;}
    var t=e.target.closest('[data-k1m-tab]');
    if(t){
      var m=t.closest('.k1m'),n=t.getAttribute('data-k1m-tab');
      m.querySelectorAll('[data-k1m-tab]').forEach(function(b){var on=b===t;b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on?'true':'false');});
      m.querySelectorAll('[data-k1m-pane]').forEach(function(p){p.hidden=p.getAttribute('data-k1m-pane')!==n;});
    }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfel-h-countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.portfel-h-countdown__close').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var sectionId = this.getAttribute('data-section');
        var bar = document.getElementById('portfel-h-countdown-' + sectionId);
        if (bar) {
          bar.classList.add('portfel-h-countdown--hidden');
          try {
            sessionStorage.setItem('portfel-h-countdown-dismissed-' + sectionId, '1');
          } catch(e) {}
        }
      });
    });

    document.querySelectorAll('.portfel-h-countdown').forEach(function(bar) {
      var sectionId = bar.id.replace('portfel-h-countdown-', '');
      try {
        if (sessionStorage.getItem('portfel-h-countdown-dismissed-' + sectionId) === '1') {
          bar.classList.add('portfel-h-countdown--hidden');
        }
      } catch(e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfel-h-sticky"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bars = document.querySelectorAll('.portfel-h-sticky');
    if (!bars.length) return;

    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:100vh;pointer-events:none;';
    document.body.appendChild(sentinel);

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        bars.forEach(function(bar) {
          if (entry.isIntersecting) {
            bar.classList.remove('portfel-h-sticky--visible');
          } else {
            bar.classList.add('portfel-h-sticky--visible');
          }
        });
      });
    }, { threshold: 0 });

    observer.observe(sentinel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfel-prod-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var toggles = document.querySelectorAll('.portfel-upsell__toggle-input');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('change', function() {
        var variantId = this.getAttribute('data-variant-id');
        var card = this.closest('.portfel-upsell__card');
        if (this.checked) {
          card.classList.add('portfel-upsell__card--active');
          /* Dispatch custom event for external integration */
          document.dispatchEvent(new CustomEvent('portfel:upsell:add', {
            detail: { variantId: variantId }
          }));
        } else {
          card.classList.remove('portfel-upsell__card--active');
          document.dispatchEvent(new CustomEvent('portfel:upsell:remove', {
            detail: { variantId: variantId }
          }));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfel-reviews-widget"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.portfel-rw__more').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var sectionId = this.getAttribute('data-section');
        var list = document.getElementById('portfel-rw-list-' + sectionId);
        if (list) {
          list.classList.add('portfel-rw__list--expanded');
          this.style.display = 'none';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
